export enum Variants {
	borderWhite = 'borderWhite',
	borderMedGray = 'borderMedGray',
	dark = 'dark',
	darkBlue = 'darkBlue',
	destructive = 'destructive',
	flatDefault = 'flatDefault',
	flatDestructive = 'flatDestructive',
	flatNeutral = 'flatNeutral',
	iconButtonDark = 'iconButtonDark',
	iconButtonLight = 'iconButtonLight',
	iconButtonMedium = 'iconButtonMedium',
	info = 'info',
	light = 'light',
	lighter = 'lighter',
	medium = 'medium',
	primary = 'primary',
	secondaryDefault = 'secondaryDefault',
	secondaryDestructive = 'secondaryDestructive',
	secondaryNeutral = 'secondaryNeutral',
	secondaryWarning = 'secondaryWarning',
	success = 'success',
	warning = 'warning',
}
